import { callApi } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { ITeamMember, ITeamMemberResponse, ITeamMembersResponse } from 'apps/fleet-planner/types'

export const fetchAllTeamMembers = (): Promise<ITeamMembersResponse> => {
  return callApi({
    endpoint: FP_ENDPOINTS.teamMembers,
    method: 'GET',
  })
}

export const createTeamMember = (
  teamMember: RecursivePartial<ITeamMember>
): Promise<ITeamMemberResponse> => {
  return callApi({
    endpoint: FP_ENDPOINTS.teamMembers,
    method: 'POST',
    body: {
      ...teamMember,
    },
  })
}

export const updateTeamMember = (
  teamMember: RecursivePartial<ITeamMember>,
  id: number
): Promise<ITeamMemberResponse> => {
  return callApi({
    endpoint: FP_ENDPOINTS.teamMembers,
    method: 'PUT',
    id,
    body: {
      ...teamMember,
    },
  })
}
